import { useState } from 'react';
import { LoginForm } from '../components/auth/LoginForm';
import { SignUpForm } from '../components/auth/SignUpForm';
import { ConfirmationForm } from '../components/auth/ConfirmationForm';
import { Box, Alert } from '@mui/material';

type AuthState = 'login' | 'signup' | 'confirmation' | 'confirmed';

/**
 * Authentication Page
 * Manages login, signup, and email confirmation flows
 */
export function AuthPage() {
  const [authState, setAuthState] = useState<AuthState>('login');
  const [signUpEmail, setSignUpEmail] = useState('');

  const handleSwitchToSignUp = () => {
    setAuthState('signup');
  };

  const handleSwitchToLogin = () => {
    setAuthState('login');
  };

  const handleSignUpSuccess = (email: string) => {
    setSignUpEmail(email);
    setAuthState('confirmation');
  };

  const handleConfirmationSuccess = () => {
    setAuthState('confirmed');
  };

  const handleBackToSignUp = () => {
    setAuthState('signup');
  };

  if (authState === 'confirmed') {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="background.default"
        p={2}
      >
        <Alert severity="success" sx={{ maxWidth: 400 }}>
          Email confirmed successfully! Please sign in with your credentials.
        </Alert>
      </Box>
    );
  }

  if (authState === 'confirmation') {
    return (
      <ConfirmationForm
        email={signUpEmail}
        onConfirmationSuccess={handleConfirmationSuccess}
        onBackToSignUp={handleBackToSignUp}
      />
    );
  }

  if (authState === 'signup') {
    return (
      <SignUpForm
        onSwitchToLogin={handleSwitchToLogin}
        onSignUpSuccess={handleSignUpSuccess}
      />
    );
  }

  return (
    <LoginForm
      onSwitchToSignUp={handleSwitchToSignUp}
    />
  );
}